export default __webpack_public_path__ + "static/media/Pink geode_primary.f98685a2.jpg";